export default function byOrder(a: { order?: number }, b: { order?: number }) {
  return (a.order || 0) > (b.order || 0) ? 1 : -1;
}
